import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UIRouter, UIRouterModule } from "@uirouter/angular";
import { ErrorPageComponent } from "./error.component";
import { errorStateDeclaration } from "./error.stateconfig";
import { RootScope } from "app/commons/services/rootScope.service";
import { error404StateDeclaration } from "./error404/error.404.stateconfig";
import { error500StateDeclaration } from "./error500/error.500.stateconfig";
import { Error404PageComponent } from "./error404/error.404.component";
import { Error500PageComponent } from "./error500/error.500.component";
import { error403StateDeclaration } from "./error403/error.403.stateconfig";
import { Error403PageComponent } from "./error403/error.403.component";
import { error502StateDeclaration } from "./error502/error.502.stateconfig";
import { error503StateDeclaration } from "./error503/error.503.stateconfig";
import { Error502PageComponent } from "./error502/error.502.component";
import { Error503PageComponent } from "./error503/error.503.component";
import { errorOopsStateDeclaration } from "./oops/error.oops.stateconfig";
import { ErrorOopsPageComponent } from "./oops/error.oops.component";
import { OpPrismHighlight } from "app/components/opPrismHighlight/opPrismHighlight.directive";

@NgModule({
    imports: [
        CommonModule,
        OpPrismHighlight,
        UIRouterModule.forChild({
            states: [
                errorStateDeclaration,
                error403StateDeclaration,
                error404StateDeclaration,
                error500StateDeclaration,
                error502StateDeclaration,
                error503StateDeclaration,
                errorOopsStateDeclaration
            ],
            config: (router: UIRouter) => {
              router.transitionService.onError(
                { from: (state) => state.includes.error },
                (transition) => {
                  const rootScope = transition.injector().get<RootScope>(RootScope);
                  rootScope.pageLoading = false;
                  rootScope.pageLoaded = true;
                  transition.abort();
                  console.log(transition);
                })
            }
        })
    ],
    declarations: [
        ErrorPageComponent,
        Error403PageComponent,
        Error404PageComponent,
        Error500PageComponent,
        Error502PageComponent,
        Error503PageComponent,
        ErrorOopsPageComponent
    ]
})
export class ErrorPagesModule {}
